import { createVanIconComponent } from "./van"

const Cross = createVanIconComponent("cross")
export default Cross
